import _ from "lodash"
import { useForm } from "@dladio/hooks"

const VisibleWrapper = ({ children }: any) => {
    const { form } = useForm()

    let bpCode = _.get(form, 'bpCode')

    return (
        <>
            {bpCode ? children : null}
        </>
    )

}

export default VisibleWrapper